import { Record } from 'immutable';

const keys: StatusTimeFields = {
  statusTimeUnit: '',
  statusTimeValue: '',
  statusTimeAsDate: false,
};

export interface StatusTimeFields {
  statusTimeValue: string;
  statusTimeUnit: string;
  statusTimeAsDate: boolean;
}

export default class StatusTimeRecord extends Record<StatusTimeFields>(keys) {}
